import React from "react";
import { useLanguageContent } from "../Components/LangueContentLoader";
import ProjectCard from "../Components/ProjectCard";
import gabLogo from "../Images/gaby-logo.png";
import photographe from "../Images/photographe.jpg";
import quai from "../Images/quai-img/quai300.jpg";
import asso from "../Images/ass2.png";
import vidCUEL from "../Images/CUEL/logo250x250.jpg";
import dice from "../Images/dice/dice2.png";
import bocauxLogo from "../Images/bocaux/logo.png";
import { motion } from "framer-motion";

export default function Projects() {
  const content = useLanguageContent();
  return (
    <motion.main
      className="project-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <article className="article-project">
        <p className="banner-text">{content.my}&nbsp;</p>
        <h1 className="banner-text salmon">{content.projects}</h1>
      </article>

      <h2 className="projects-titles">
        <hr />
        Marketing & communication Projects
      </h2>

      <section className="projects-parts dev-box">
        <article className="dev-project-resume">
          <ProjectCard image={vidCUEL} link="/CUEL" />
        </article>

        <article className="dev-project-resume">
          <ProjectCard image={bocauxLogo} link="/LesBocauxProject" />
        </article>

        <article className="dev-project-resume">
          <ProjectCard image={gabLogo} link="/GabyProject" />
        </article>
      </section>

      <h2 className="projects-titles">
        <hr />
        Dev Projects
      </h2>
      <section className="projects-parts dev-box">
        <article className="dev-project-resume">
          <ProjectCard
            title="Photographe"
            description={content.photographerResume}
            image={photographe}
            link="/PhotographerProject"
          />
        </article>
        <article className="dev-project-resume">
          <ProjectCard
            title="Le Quai Antique"
            description={content.quaiResume}
            image={quai}
            link="/QuaiProject"
          />
        </article>
        <article className="dev-project-resume">
          <ProjectCard
            title="Les Animaux Du 27"
            description={content.assoResume}
            image={asso}
            link="/AssoProject"
          />
        </article>
        <article className="dev-project-resume">
          <ProjectCard
            title="The Dice Game"
            description={content.diceGameResume}
            image={dice}
            link="/DiceGameProject"
          />
        </article>
      </section>
    </motion.main>
  );
}
